import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: calc(var(--metrics-xl) + 1rem);
  margin-top: var(--metrics-m);
`;
